// extracted by mini-css-extract-plugin
export default {"addbook":"AddBook_addbook__FEGKz","select":"AddBook_select__9eQot"};